module.exports = __webpack_public_path__ + "img/qr-code.ff3623aa.svg";